"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Inline_1 = __importDefault(require("../../../../layouts/Inline"));
const Stack_1 = __importDefault(require("../../../../layouts/Stack"));
const StatusIndicator_1 = __importDefault(require("../../../StatusIndicator"));
const FileTokenLabel = ({ name, size, lastModified }) => {
    const displaySize = react_1.useMemo(() => {
        if (!size)
            return null;
        const k = 1000;
        const dm = 2;
        const sizes = ['bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(size) / Math.log(k));
        return `Size: ${parseFloat((size / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }, [size]);
    const displayLastModified = react_1.useMemo(() => {
        if (lastModified) {
            const date = new Date(lastModified);
            return `Last modified: ${date.toLocaleString()}`;
        }
        return null;
    }, [lastModified]);
    return (react_1.default.createElement(Inline_1.default, { spacing: "xs" },
        react_1.default.createElement(StatusIndicator_1.default, { statusType: "positive" }),
        react_1.default.createElement(Stack_1.default, { spacing: "none" },
            react_1.default.createElement("b", null, name),
            displaySize,
            displayLastModified)));
};
exports.default = FileTokenLabel;
//# sourceMappingURL=index.js.map